module.exports = __webpack_public_path__ + "static/img/kiko-topbg.740ab8a5.png";